export default "__VITE_ASSET__a_KLn6QZ__"